// eslint-disable-next-line import/no-anonymous-default-export
export default {
  APP_ENV: process.env.REACT_APP_APP_ENV ? String(process.env.REACT_APP_APP_ENV) : 'production',
  APP_URL: process.env.REACT_APP_APP_URL ? String(process.env.REACT_APP_APP_URL) : '',
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL ? String(process.env.REACT_APP_PUBLIC_URL) : '',
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL ? String(process.env.REACT_APP_BACKEND_URL) : '',
  GTM_ID: process.env.REACT_APP_GTM_ID ? String(process.env.REACT_APP_GTM_ID) : '',
  JWT_PRIVATE_KEY: process.env.JWT_PRIVATE_KEY ? String(process.env.JWT_PRIVATE_KEY) : '',
}
